import { AdditionalCostRestEndpointService } from '@api'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { handleError } from '@/utils/error'

export function useDeleteAdditionalCost() {
  const toast = useToast()
  const queryClient = useQueryClient()

  const deleteCostMutation = useMutation(
    (id: number) =>
      AdditionalCostRestEndpointService.dashboardDeleteAdditionalCost({
        costId: id,
      }),
    {
      onSuccess: () => {
        toast.success('Additional cost successfully deleted')
      },
      onError: (error) => {
        handleError(
          error,
          'Error occurred while deleting cost, please try again',
        )
      },
      onSettled: () => {
        queryClient.invalidateQueries(['accounting_data'])
        queryClient.invalidateQueries(['additional-costs'])
      },
    },
  )

  const deleteCost = (id: number) => {
    return deleteCostMutation.mutateAsync(id)
  }

  return {
    deleteCost,
    isLoading: deleteCostMutation.isLoading,
  }
}
